import React, { useMemo, useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import type { PurchaseOrderResponse } from "../../api_utils/types";
import { useCurrencies, usePurchaseOrder } from "../../api_utils/requests";
import { getIdFromPath } from "../../helper_functions/utils";
import { PurchaseOrderDraftPageSkeleton } from "../common/skeletons";

import PurchaseOrderDraft from "./Draft";
import PurchaseOrderOrdered from "./Ordered";
import PurchaseOrderClosed from "./Closed";

function Show(): React.JSX.Element {
  const purchaseOrderId = useMemo(() => getIdFromPath(), []);

  const { data: currencies } = useCurrencies();
  const { data: purchaseOrderData, isLoading } = usePurchaseOrder(purchaseOrderId);
  const { purchaseOrder } = purchaseOrderData || {};
  const queryClient = useQueryClient();
  const onSave = useCallback((response: PurchaseOrderResponse): void => {
    queryClient.setQueryData(["purchase_orders", purchaseOrderId], response);
  }, [queryClient, purchaseOrderId]);

  const renderPageContent = (): React.JSX.Element => {
    if (!purchaseOrder) return null;

    const { state } = purchaseOrder;
    const ComponentMap = {
      draft: PurchaseOrderDraft,
      ordered: PurchaseOrderOrdered,
      closed: PurchaseOrderClosed,
    };

    const SelectedComponent = ComponentMap[state];

    return SelectedComponent ? (
      <SelectedComponent currencies={currencies} onSave={onSave} response={purchaseOrderData} />
    ) : null;
  };

  return isLoading ? <PurchaseOrderDraftPageSkeleton /> : renderPageContent();
}

export default Show;
